import { appIntl } from '@components/locale/IntlGlobalProvider';
import { FormikErrors, FormikTouched, getIn } from 'formik';
import { isEqual } from 'lodash';
import * as Yup from 'yup';

import { Error } from '@/types/validation.types';

export const validateEmail: Yup.StringSchema = Yup.string()
  .matches(/@[^.]*\./, 'form.email')
  .email('form.email');

export function formatError(error?: Error): string | null {
  if (error === undefined) {
    return null;
  }
  if (typeof error === 'string') {
    return appIntl().formatMessage({ id: error });
  }
  return appIntl().formatMessage({ id: error.id }, error.values);
}

export function isInvalid<T extends object>(key: string, touched: FormikTouched<T>, errors: FormikErrors<T>) {
  const isTouched = getIn(touched, key.toString());
  const error = getIn(errors, key.toString());
  return Boolean(isTouched && error);
}

export function hasChanged<T extends object>(path: string, current: T, initial: T) {
  return !isEqual(getIn(current, path), getIn(initial, path));
}
